<template>
  <div>
    <template v-if="routes.length > 0">
      <ul class="dashboard-routes">
        <li v-for="route in routes" :key="route.uuid">
          <Link :to="`/routes/${route.uuid}`" class="dashboard-route">
            <h3>{{ route.name }} ({{ $t('meta.project') }}: {{ route.project.name }})</h3>
            <div class="route-meta">
              <p class="dashboard-comment">
                <span class="material-icons">chat</span
                ><span>{{ route.count_comments + route.count_images }} {{ $t('dashboard.reactions') }}</span>
              </p>
            </div>
            <p>
              <span class="meta-wrap"
                ><strong>{{ $t('dashboard.date') }}:</strong> {{ route.date_formatted }}</span
              >
              <span class="meta-wrap"
                ><strong>{{ $t('routes.stops') }}:</strong> {{ route.count_stops_done }}
                {{ $t('dashboard.of') }}
                {{ route.count_stops - 2 }}
                {{ $t('dashboard.done') }}</span
              >
              <span class="meta-wrap"
                ><strong>{{ $t('dashboard.containers') }}:</strong> {{ route.count_containers }}</span
              >
              <span v-if="route.driver" class="meta-wrap">
                <strong>{{ $t('dashboard.vehicle') }}:</strong>
                {{ route.driver.vehicle_name }}
              </span>
            </p>
            <ul>
              <li v-for="stop in route.stops" :key="stop.uuid">
                <div v-if="getStopIcon(stop)" class="dashboard-route-stop" :class="`stat-${stop.status}`">
                  <span class="material-icons">{{ getStopIcon(stop) }}</span>
                </div>
              </li>
            </ul>
          </Link>
        </li>
      </ul>
    </template>
    <div v-else class="alert alert-info">{{ $t('dashboard.noRoutes') }}</div>
  </div>
</template>

<script>
import Link from '@/components/Link'

import routeStopUtils from '@/utils/routeStop'

export default {
  name: 'DashboardRoutes',
  mixins: [routeStopUtils],
  components: {
    Link,
  },
  props: {
    routes: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss">
.dashboard-routes {
  margin: 0;
  padding: 0;

  .route-meta {
    position: absolute;
    right: 25px;
    top: 25px;

    p {
      display: inline-block;
      background: #f6f6f6;
      margin: 0 0 0 10px;
      padding: 6px 16px;
      border-radius: var(--border-radius-m);
      font-size: 14px;

      span {
        display: inline-block;
        vertical-align: middle;
      }

      .material-icons {
        margin-right: 5px;
        font-size: 18px;
      }
    }
  }

  .meta-wrap {
    display: inline-block;
    background: #f6f6f6;
    margin-right: 10px;
    padding: 6px 16px;
    border-radius: var(--border-radius-m);
    font-size: 14px;
  }

  li {
    list-style-type: none;
    position: relative;

    .dashboard-route {
      display: block;
      border: 1px solid #f1f1f1;
      margin-bottom: 10px;
      padding: 20px;
      border-radius: 7px;
      color: #444;
    }

    .dashboard-route:hover {
      border: 1px solid #e0e0e0;
      background: #fcfcfc;
    }

    h3 {
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 15px;
    }

    ul {
      margin: 0;
      padding: 0;

      li {
        margin: 0;
        display: inline-block;
        padding: 0;

        .dashboard-route-stop {
          width: 30px;
          height: 30px;
          margin: 0 5px 5px 0;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: var(--border-radius-m);

          > span {
            color: #fff;
            font-size: 1.5rem;
          }

          &.stat-pending {
            background: #ffba00;
          }

          &.stat-emptied {
            background: #1c9600;
          }

          &.stat-skipped {
            background: #dadada;

            span {
              color: #444;
            }
          }
        }
      }

      li:last-child {
        margin-bottom: 2px;
      }
    }
  }

  li:last-child {
    margin-bottom: 0;
  }
}
</style>
